import { elements } from "chart.js";
import React from "react";

// Lazy load only the pages you need
const Dashboard = React.lazy(() => import("../../pages/seller/Dashboard"));
const ViewOrders = React.lazy(() => import("../../pages/seller/ViewOrders"));
const OrderDetail = React.lazy(() =>
  import("../../pages/seller/SellerOrderDetail")
);
const Products = React.lazy(() => import("../../pages/seller/Products"));
const ProductDetail = React.lazy(() =>
  import("../../pages/seller/SellerProductDetailPage")
);
const UploadKyc = React.lazy(() => import("../../pages/seller/UploadKyc"));
const UploadKycForm = React.lazy(() =>
  import("../../pages/seller/UploadKycForm")
);
const Certificates = React.lazy(() =>
  import("../../pages/seller/Certificates")
);
const CertificatesForm = React.lazy(() =>
  import("../../pages/seller/CertificatesForm")
);
const AddProduct = React.lazy(() =>
  import("../../pages/seller/AddProduct/AddProduct")
);
const ViewTrash = React.lazy(() => import("../../pages/seller/ViewTrash"));
const MetalPrice = React.lazy(() => import("../../pages/seller/MetalPrice"));
const SellerBids = React.lazy(() => import("../../pages/seller/SellerBids"));
const Notifications = React.lazy(() =>
  import("../../pages/seller/Notifications")
);
const Chats = React.lazy(() => import("../../pages/seller/SellerChatPage"));
const SellerProfile = React.lazy(() =>
  import("../../pages/seller/SellerProfile")
);
const SellerEditProfile = React.lazy(() =>
  import("../../pages/seller/SellerEditProfile")
);
const ChangePassword = React.lazy(() =>
  import("../../pages/seller/ChangePassword")
);
const SellerEditAddress = React.lazy(() =>
  import("../../pages/seller/AddressFormPage")
);
const RequestedBids = React.lazy(() =>
  import("../../pages/seller/RequestedBids")
);
const RequestedBidOrders = React.lazy(() =>
  import("../../pages/seller/RequestedBidOrders")
);
const ReceivedOffers = React.lazy(() =>
  import("../../pages/seller/ReceivedOffers")
);
const ReceivedOffersDetail = React.lazy(() =>
  import("../../pages/seller/SellerOfferDetail")
);
const RangeRequested = React.lazy(() =>
  import("../../pages/seller/RangeRequested")
);

const ProfileVerification = React.lazy(() =>
  import("../../pages/seller/VerificationList")
);

const VerifyProfile = React.lazy(() =>
  import("../../pages/seller/VerificationForm")
);

const routes = [
  { path: "/seller/dashboard", name: "Dashboard", element: Dashboard },
  {
    path: "/seller/verification-list",
    name: "Profile Verification",
    element: ProfileVerification,
  },
  {
    path: "/seller/verification-form",
    name: "Verify Profile",
    element: VerifyProfile,
    breadcrumb: ["/seller/verification-list"],
  },
  { path: "/seller/view-orders", name: "Orders", element: ViewOrders },
  {
    path: "/seller/order-detail/:id",
    name: "Order Detail",
    element: OrderDetail,
    breadcrumb: ["/seller/view-orders"],
  },
  { path: "/seller/products", name: "Create Bid", element: Products },
  {
    path: "/seller/product-detail/:id",
    name: "Product Detail",
    element: ProductDetail,
    breadcrumb: ["/seller/products"],
  },
  { path: "/seller/upload-kyc", name: "Verify Profile", element: UploadKyc },
  {
    path: "/seller/upload-kyc-form",
    name: "Verification Form",
    element: UploadKycForm,
    breadcrumb: ["/seller/upload-kyc"],
  },
  {
    path: "/seller/add-product",
    name: "Add Product",
    element: AddProduct,
    breadcrumb: ["/seller/products"],
  },
  {
    path: "/seller/add-product/:id",
    name: "Edit Product",
    element: AddProduct,
    breadcrumb: ["/seller/products"],
  },
  {
    path: "/seller/view-trash",
    name: "View Trash",
    element: ViewTrash,
    breadcrumb: ["/seller/products"],
  },
  /*
  {
    path: "/seller/certificate",
    name: "Certificates",
    element: Certificates,
  },
  {
    path: "/seller/certificate-form",
    name: "Certificates Form",
    element: CertificatesForm,
    breadcrumb: ["/seller/certificate"],
  },
  */
  { path: "/seller/metal-price", name: "Metal Price", element: MetalPrice },
  { path: "/seller/seller-bids", name: "Seller Bids", element: SellerBids },
  {
    path: "/seller/notifications",
    name: "Notifications",
    element: Notifications,
  },
  {
    path: "/seller/chat",
    name: "Chats",
    element: Chats,
  },
  { path: "/seller/profile", name: "Profile", element: SellerProfile },
  {
    path: "/seller/edit-profile",
    name: "Edit Profile",
    element: SellerEditProfile,
    breadcrumb: ["/seller/profile"],
  },
  {
    path: "/seller/change-password",
    name: "Change Password",
    element: ChangePassword,
    breadcrumb: ["/seller/profile"],
  },
  {
    path: "/seller/address",
    name: "Add New Address",
    element: SellerEditAddress,
    breadcrumb: ["/seller/profile"],
  },
  {
    path: "/seller/address/:id?",
    name: "Edit Address",
    element: SellerEditAddress,
    breadcrumb: ["/seller/profile"],
  },
  {
    path: "/seller/requested-bids",
    name: "Requested Bids",
    element: RequestedBids,
  },
  {
    path: "/seller/requested-bid-orders",
    name: "Requested Bid Orders",
    element: RequestedBidOrders,
  },
  {
    path: "/seller/received-offers",
    name: "Received Offers",
    element: ReceivedOffers,
  },
  {
    path: "/seller/offers-detail/:id?",
    name: "Received Offers Detail",
    element: ReceivedOffersDetail,
    breadcrumb: ["/seller/received-offers"],
  },
  {
    path: "/seller/range-requested",
    name: "Delivery Requests",
    element: RangeRequested,
  },
];

export default routes;
